/**
 * 各种画echarts图表的方法都封装在这里
 * 注意：这里echarts没有采用按需引入的方式，只是为了方便学习
 */

import echarts from 'echarts'
import heze from '@/assets/heze.json'
const install = function(Vue) {
    Object.defineProperties(Vue.prototype, {
        $chart: {
            get() {
                return {
                    //画一条简单的线
                    line1: function(id, datanew) {
                        echarts.registerMap('heze', heze)
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        console.log(datanew, '3')
                        const optionData = {
                            baseOption: {
                                tooltip: {
                                    trigger: 'item',
                                    formatter: function(e) {
                                        var html = ''
                                        if (e.data.iState == 1) {
                                            html = "<div style='width:220px;height:110px;border-radius:5px;border:1px solid #fd5705;background:#fff;margin:-5px;text-align:center;padding-top:10px'><img src='" + e.data.nvcNodeLogo + "' style='width=203px;height:76px'><br><span class='color_sub' style='padding-top:5px;display:block' >进入" + e.data.name + "</span></div>"
                                        } else {
                                            html = "<div style='width:220px;height:80px;border-radius:5px;border:1px solid #fd5705;background:#fff;color:#000;text-align:center;padding-top:25px;margin:-5px;'><i class='iconfont icon-warning color_sub f40'></i><br><span style='padding-top:10px;display:block'>此节点暂未开通服务</span></div>"
                                        }
                                        return html
                                    }
                                },
                                visualMap: {
                                    min: 1,
                                    max: 6,
                                    show: false,
                                    calculable: true,
                                    inRange: {
                                        color: ['#fed3e6', '#c6cde7', "#ecf7c7", "#f3e0b8", "#c5e6d3", "#fffbde"]
                                    },
                                },
                                geo: {
                                    label: {
                                        show: true,
                                        fontSize: "16px",
                                        color: "#000"
                                    }
                                },

                                series: [{
                                    name: '热图',
                                    type: 'map',
                                    mapType: 'heze',
                                    zoom: 1.2,
                                    data: datanew,
                                    label: {
                                        show: true,
                                    },
                                }, ],

                            },
                        }

                        this.chart.setOption(optionData);
                        this.chart.on('click', function(params) {
                            console.log(params, '点击')
                            if (params.data.iState == 1) {
                                
                                if (params.data.name == '物流曹县') {
                                    window.open("http://" + "caoxian.5608656.com/", "_blank")
                                } else if (params.data.name == '物流单县') {
                                    window.open("http://" + "shanxian.5608656.com/", "_blank")
                                } else if (params.data.name == '物流郓城') {
                                    window.open("http://" + "yuncheng.5608656.com/", "_blank")
                                } else if (params.data.name == '物流东明') {
                                    window.open("http://" + "dongming.5608656.com/", "_blank")
                                } else if (params.data.name == '物流巨野') {
                                    window.open("http://" + "juye.5608656.com/", "_blank")
                                } else if (params.data.name == '物流鄄城') {
                                    window.open("http://" + "juancheng.5608656.com/", "_blank")
                                } else if (params.data.name == '物流成武') {
                                    window.open("http://" + "chengwu.5608656.com/", "_blank")
                                } else if (params.data.name == '物流定陶') {
                                    window.open("http://" + "dingtao.5608656.com/", "_blank")
                                } else if (params.data.name == '物流牡丹') {
                                    window.open("http://" + "mudan.5608656.com/", "_blank")
                                } 

                            }
                        })
                    },
                }
            }
        }
    })
}

export default {
    install
}


// WEBPACK FOOTER //
// ./src/assets/myCharts.js